import React from 'react';
import { FaFacebook, FaYoutube, FaWhatsapp, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

export default function Footer() {
    return (
        <footer className="bg-gray-900 text-white py-8 sm:py-12">
            <div className="max-w-6xl mx-auto px-4 sm:px-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
                    {/* Brand Section */}
                    <div>
                        <div className="flex items-center gap-3 mb-4">
                            <div className="flex-shrink-0">
                                <img src="logo.png" alt="Logo" className="h-9 w-auto" />
                            </div>
                            <span className="text-2xl font-bold lemon-milk">Sudesh Maths</span>
                        </div>
                        <p className="text-gray-400 text-sm mb-4 poppins">
                            Excellence in Mathematics Education
                        </p>
                        <div className="flex gap-3">
                            <div className="w-8 h-8 bg-blue-600 rounded flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                                <FaFacebook className="text-white text-sm" />
                            </div>
                            <div className="w-8 h-8 bg-gray-600 rounded flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                                <FaYoutube className="text-white text-sm" />
                            </div>
                            <div className="w-8 h-8 bg-blue-500 rounded flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                                <FaWhatsapp className="text-white text-sm" />
                            </div>
                        </div>
                    </div>

                    {/* Contact Info */}
                    <div>
                        <h3 className="font-bold text-lg mb-4 text-white lemon-milk">Contact</h3>
                        <div className="space-y-2 text-gray-400 text-sm poppins">
                            <p className="flex items-center gap-2">
                                <FaPhone className="text-blue-400" />
                                <span>0772 700 701</span>
                            </p>
                            <p className="flex items-center gap-2">
                                <FaMapMarkerAlt className="text-blue-400" />
                                <span>Nugegoda: 0112 817 028</span>
                            </p>
                            <p className="flex items-center gap-2">
                                <FaMapMarkerAlt className="text-blue-400" />
                                <span>Gampaha: 0332 248 544</span>
                            </p>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="font-bold text-lg mb-4 text-white lemon-milk">Quick Links</h3>
                        <div className="space-y-2 text-gray-400 text-sm poppins">
                            <p><a href="#" className="hover:text-blue-400 transition-colors">Time Tables</a></p>
                            <p><a href="#" className="hover:text-blue-400 transition-colors">Enrollment</a></p>
                            <p><a href="#" className="hover:text-blue-400 transition-colors">Contact Us</a></p>
                            <p><a href="#" className="hover:text-blue-400 transition-colors">Class Schedules</a></p>
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="border-t border-gray-700 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
                    <p className="text-gray-500 text-sm poppins">&copy; 2024 Sudesh Maths. All rights reserved.</p>
                    <div className="flex gap-6 mt-3 md:mt-0">
                        <a href="#" className="text-gray-500 hover:text-blue-400 transition-colors text-sm poppins">Privacy</a>
                        <a href="#" className="text-gray-500 hover:text-blue-400 transition-colors text-sm poppins">Terms</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
